module.exports = __webpack_public_path__ + "img/logo.913d2cac.svg";